module.exports = __webpack_public_path__ + "static/media/the-chegos-chicken.6a69b11e.md";